// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"840":"8bf65104","963":"0122ec03"}[chunkId] + ".chunk.js";
};